import { render, staticRenderFns } from "./YwList.vue?vue&type=template&id=148dc2a6&scoped=true"
import script from "./YwList.vue?vue&type=script&lang=js"
export * from "./YwList.vue?vue&type=script&lang=js"
import style0 from "./YwList.vue?vue&type=style&index=0&id=148dc2a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148dc2a6",
  null
  
)

export default component.exports